
export default {
  name: "WhatCanWeTransport",

  data: function () {
    return {
      isShowMore: false
    }
  },

  props: {
    title: {
      type: String,
      default: ""
    },
    products: {
      type: Array,
      default: () => {
        return []
      }
    },

    light: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    items: function () {
      if (!this.isShowMore) {
        return [...this.products].splice(0, 8)
      }

      return this.products
    }
  },

  components: {
    Card: () => import("~/components/category/ProductCardSmallImage.vue")
  },

  methods: {
    openMore: function () {
      this.isShowMore = true;
    }
  }
}
